import { render, staticRenderFns } from "./menu_component.vue?vue&type=template&id=b4b787e4&scoped=true&"
import script from "../assets/js/menu.js?vue&type=script&lang=js&"
export * from "../assets/js/menu.js?vue&type=script&lang=js&"
import style0 from "../assets/css/menu.css?vue&type=style&index=0&rel=stylesheet&lang=css&"
import style1 from "./menu_component.vue?vue&type=style&index=1&id=b4b787e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b787e4",
  null
  
)

export default component.exports